
import React from "react";
import classes from "./footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className={classes.footerWave}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
        >
          <path
            fill="#FFF5F9"
            d="M0,100 C320,20 480,40 720,50 C960,60 1120,40 1440,100 L1440,0 L0,0 Z"
          ></path>
        </svg>
      </div>
      <div className={classes.footerContent}>
        <div className={classes.footerColumns}>
          <div className={classes.footerColumn}>
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
            
              <li>
                <a href="https://www.instagram.com/sharma_panda/">Contact Us</a>
              </li>
            </ul>
          </div>
          <div className={classes.footerColumn}>
            <h3>Connect With Us</h3>
            <div className={classes.socialIcons}>
              <a href="mailto:corelarris@gmail.com" className={classes.socialIcon}>
                <span className={classes.socialEmoji}>📘</span>
              </a>
              <a href="https://www.instagram.com/sharma_panda/" className={classes.socialIcon}>
                <span className={classes.socialEmoji}>📱</span>
              </a>
             
            </div>
     
          </div>
        </div>
        <div className={classes.footerBottom}>
          <p>&copy; 2025 My Cat's Name. All rights reserved.</p>
       
          <div className={classes.footerLogo}>
            {/* Cat Logo */}
            <svg viewBox="0 0 50 50" className={classes.catFooterLogo}>
              {/* Cat Head */}
              <circle cx="25" cy="25" r="15" fill="#FFD9E8" stroke="#FF9DC4" strokeWidth="1" />
              
              {/* Cat Ears */}
              <path
                d="M15,12 L10,3 L20,10 Z"
                fill="#FFD9E8"
                stroke="#FF9DC4"
                strokeWidth="1"
              />
              <path
                d="M35,12 L40,3 L30,10 Z"
                fill="#FFD9E8"
                stroke="#FF9DC4"
                strokeWidth="1"
              />

              {/* Cat Eyes */}
              <circle cx="18" cy="23" r="2" fill="#000" />
              <circle cx="32" cy="23" r="2" fill="#000" />

              {/* Cat Nose */}
              <polygon points="25,28 23,30 27,30" fill="#FF9DC4" />

              {/* Cat Mouth */}
              <path
                d="M23,30 Q25,32 27,30"
                stroke="#FF9DC4"
                strokeWidth="1"
                fill="transparent"
              />

              {/* Cat Whiskers */}
              <path
                d="M10,24 H5"
                stroke="#000"
                strokeWidth="1"
              />
              <path
                d="M10,26 H5"
                stroke="#000"
                strokeWidth="1"
              />
              <path
                d="M40,24 H45"
                stroke="#000"
                strokeWidth="1"
              />
              <path
                d="M40,26 H45"
                stroke="#000"
                strokeWidth="1"
              />
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
